import moment from 'moment'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { getDisplayQuestions, RATING_LABELS, RATING_COLORS, RECOMMEND_COLORS, RECOMMEND_LABELS, YESNO_COLORS, YESNO_LABELS } from './feedbackSurveyConstants'

const TYPE_TEXT = { exit: 'Largim', renewal: 'Vazhdim i kontratës', probation: 'Periudhë prove' }

const EmployeeFeedbackModal = ({ survey, onClose }) => {
  const questions = getDisplayQuestions(survey?.type)
  return (
    <Modal size='lg' isOpen={!!survey} toggle={onClose}>
      {survey && (
        <>
          <ModalHeader toggle={onClose}>
            Feedback — {survey.employee?.first_name} {survey.employee?.last_name}
          </ModalHeader>
          <ModalBody style={{ padding: 0 }}>
            <div style={{ backgroundColor: '#f8f9fa', padding: '12px 24px', borderBottom: '1px solid #e4eaec', display: 'flex', gap: 24 }}>
              <div>
                <div style={{ fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: 0.5 }}>Menaxher</div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>
                  {survey.manager?.first_name} {survey.manager?.last_name}
                </div>
              </div>
              <div>
                <div style={{ fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: 0.5 }}>Datë</div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{moment(survey.completedAt).format('DD.MM.YYYY')}</div>
              </div>
              <div>
                <div style={{ fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: 0.5 }}>Lloji</div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{TYPE_TEXT[survey.type] || 'Periudhë prove'}</div>
              </div>
            </div>
            <div style={{ padding: '8px 24px 16px' }}>
              {questions.map((q, i) => (
                <div key={q.key} style={{ padding: '16px 0', borderBottom: i < questions.length - 1 ? '1px solid #f0f2f5' : 'none' }}>
                  <div style={{ fontSize: 11, color: '#aaa', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>
                    {q.label}
                  </div>
                  {q.type === 'rating' && (
                    <span style={{ display: 'inline-block', padding: '4px 14px', borderRadius: 20, backgroundColor: RATING_COLORS[survey[q.key]] || '#ccc', color: '#fff', fontSize: 13, fontWeight: 600 }}>
                      {RATING_LABELS[survey[q.key]] || '-'}
                    </span>
                  )}
                  {q.type === 'recommend' && (
                    <span style={{ display: 'inline-block', padding: '4px 14px', borderRadius: 20, backgroundColor: RECOMMEND_COLORS[survey[q.key]] || '#ccc', color: '#fff', fontSize: 13, fontWeight: 600 }}>
                      {RECOMMEND_LABELS[survey[q.key]] || '-'}
                    </span>
                  )}
                  {q.type === 'yesno' && (
                    <span style={{ display: 'inline-block', padding: '4px 14px', borderRadius: 20, backgroundColor: YESNO_COLORS[survey[q.key]] || '#ccc', color: '#fff', fontSize: 13, fontWeight: 600 }}>
                      {YESNO_LABELS[survey[q.key]] || '-'}
                    </span>
                  )}
                  {q.type === 'text' && (
                    <p style={{ margin: 0, color: '#444', fontSize: 14 }}>{survey[q.key] || '-'}</p>
                  )}
                  {q.commentKey && survey[q.commentKey] && (
                    <div style={{ borderLeft: '3px solid #e4eaec', paddingLeft: 12, marginTop: 10 }}>
                      <p style={{ margin: 0, color: '#888', fontStyle: 'italic', fontSize: 13 }}>{survey[q.commentKey]}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color='secondary' outline onClick={onClose}>Mbyll</Button>
          </ModalFooter>
        </>
      )}
    </Modal>
  )
}

export default EmployeeFeedbackModal
